/**
 * The mapping report (2.G deliverable 4): what a mapper did not map, the module flags it counted
 * and never parsed (decision 213 ruling 3), the input's counts and the warnings. Paths only, never
 * values: a report may be shown and logged.
 */
import { FOUNDRY_COVERAGE, generalizePath, leafPaths, uncoveredPaths, } from '../../schema/coverage/foundry.js';
import { arr, isRec, rec } from './input.js';
export const MAPPING_WARNING_CODES = [
    'rules_2024_content',
    'world_rules_modern',
    'stamp_older_than_layout',
    'unknown_condition',
    'unknown_damage_type',
    'currency_unknown_rate',
    'item_type_unmapped',
    'item_id_invalid',
    'activity_unmapped',
    'description_sanitized',
    'value_invalid',
    'schema_issue',
    'input_too_deep',
    'input_too_large',
];
/** Paths the mappers read that the coverage table does not list: dnd5e 5.0's spell form. */
export const MAPPER_EXTRA_ROWS = [
    { path: 'items[].system.preparation.mode', character: 'items[].spell.method', statblock: null },
    {
        path: 'items[].system.preparation.prepared',
        character: 'items[].spell.prepared',
        statblock: null,
    },
];
const TABLE = [...FOUNDRY_COVERAGE, ...MAPPER_EXTRA_ROWS];
export function unmappedPaths(actor) {
    return [...new Set(uncoveredPaths(actor, TABLE).map(generalizePath))].sort();
}
export function countModuleFlags(actor) {
    const modules = new Set();
    let leafCount = 0;
    const visit = (flags) => {
        for (const [key, value] of Object.entries(rec(flags))) {
            const dot = key.indexOf('.');
            const module = dot === -1 ? key : key.slice(0, dot);
            if (module === 'dnd5e' || module === '')
                continue;
            modules.add(module);
            leafCount += leafPaths(value).length;
        }
    };
    visit(rec(actor).flags);
    for (const item of arr(rec(actor).items))
        visit(rec(item).flags);
    return { modules: [...modules].sort(), leafCount };
}
export function countInput(actor) {
    const items = arr(rec(actor).items);
    let activities = 0;
    let effects = arr(rec(actor).effects).length;
    let transferredEffects = 0;
    for (const item of items) {
        activities += Object.keys(rec(rec(rec(item).system).activities)).length;
        for (const effect of arr(rec(item).effects)) {
            effects += 1;
            if (!isRec(effect) || effect.transfer !== false)
                transferredEffects += 1;
        }
    }
    return { items: items.length, activities, effects, transferredEffects };
}
//# sourceMappingURL=report.js.map